import { apiRequest } from '../Api/ApiRequest';
import {queryStringFromFields} from "../../helpers/QueryString";

// eslint-disable-next-line @typescript-eslint/naming-convention
export function api_getTicket(ticketId, query: { include: string }) {

  // TODO: change to /tickets once the API is updated
  return apiRequest({
    url: `/tickets/${ticketId}${queryStringFromFields(query)}`,
    method: 'get',
    headers: { 
      Authorization: `bearer ${localStorage.getItem('hso-api-token')}`
  },
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function api_escalateTicket(ticketId, note) {

  // TODO: change to /tickets once the API is updated
  return apiRequest({
    url: `/tickets/${ticketId}/escalate`,
    method: 'post',
    headers: { Authorization: `bearer ${localStorage.getItem('hso-api-token')}` },
    data: { note },
  }).then(
    (resp) => resp,
  ).catch(
    (error) => error,
  );

}
